










































































































































































































import { Reminder } from '@/communications/reminders/models/reminder-models';
import { EmailRemindersStore } from '@/communications/reminders/store/email-reminders-store';
import { TextRemindersStore } from '@/communications/reminders/store/text-reminders-store';
import { FeatureConstants } from '@/features/feature-constants';
import { FeaturesStore } from '@/features/features-store';
import { AppStateStore } from '@/store/app-state-store';
import { CrmBreakpointsMixin } from '@/styles/crm-breakpoints-mixin';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import { DataTableHeader } from 'vuetify';
import { getModule } from 'vuex-module-decorators';
import { LoadingStore } from '@/store/loading-store';
import { MessageTableData, MessageTemplate } from '@/communications/templates/models/message-template';
import { StaffUtils } from '@/staff/staff-utils';
import { PermissionName } from '@/staff/models/user-permission-models';
import { AuthStore } from '@/store/auth-store';
import { OrgsStore } from '@/store/orgs-store';
import { Org } from '@/models/organization/org';
import { ApiParameters } from '@/repositories/abstract-repository';
import { TemplatesRepository } from '@/communications/templates/repositories/templates-repository';
import { TemplateTagsRepository } from '@/communications/templates/repositories/template-tags-repository';
import { processTemplateTags, formatTemplateTags } from '@/communications/templates/template-tags-utils';
import { DataTableOptions } from '@/models/datatables';
import { getPagination } from '@/core/datatables-utils';
import { getSortingParameters } from '@/core/sort-utils';
import CreateTemplate from '@/communications/templates/components/CreateTemplate.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import MassCopyTemplatesModal from '@/communications/templates/components/MassCopyTemplatesModal.vue';
import { EventTypes } from '@/constants/event-type-constants';
import { Route } from 'vue-router';
import { ClientInfoStore } from '@/organizations/corporate/stores/client-info-store';
import { LayoutTabsStore } from '@/store/layout-tabs-store';
import { TabPermissions } from '@/core/tab-permissions';

const appState = getModule(AppStateStore);
const authState = getModule(AuthStore, store);
const loadingState = getModule(LoadingStore);
const orgStore = getModule(OrgsStore);
const featuresStore = getModule(FeaturesStore);
const staffUtils = new StaffUtils();
const emailReminderStore = getModule(EmailRemindersStore);
const textReminderStore = getModule(TextRemindersStore);
const templatesRepo = new TemplatesRepository();
const templateTagsRepo = new TemplateTagsRepository();
const clientInfoStore = getModule(ClientInfoStore);
const layoutTabsStore = getModule(LayoutTabsStore, store);

Component.registerHooks([
    'beforeRouteEnter'
]);
@Component({
    components: { MassCopyTemplatesModal, CreateTemplate, Loading }
})
export default class MessageTemplates extends Mixins(CrmBreakpointsMixin, LocaleMixin) {

    get isNewMarketingTemplates(): boolean {
        return featuresStore.isFeatureEnabled(FeatureConstants.NEW_MARKETING_TEMPLATES);
    }

    get canAddTabs(): boolean {
        return TabPermissions.canAddTabs();
    }

    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        const canViewTemplatesRemindersAttachments = await staffUtils.getUserPermission(PermissionName.AutomationViewMessageTemplates);
        if (canViewTemplatesRemindersAttachments) {
            // Allow user to navigate to this page.
            next();
        } else {
            // Access denied. Send user home.
            next({ name: 'home' });
        }
    }

    // Whether or not this is an email/text template or a reminder/notification
    @Prop({ type: Boolean, default: true }) readonly isTemplate!: boolean;

    private loadingKey = this.isTemplate ? 'messageTemplates' : 'remindersKey';
    private isLoading = true;
    private rootOrg: Org | null = null;
    private automationMessageTemplatesPermissionGrant = false;
    private selectedItem: MessageTemplate | Reminder | MessageTableData | null = null;

    // Normal email and text template stuff - pagination.
    private currentItemCount = 0;
    private templateItems: Array<MessageTableData> = [];
    private options: DataTableOptions = { itemsPerPage: 25, page: 1 };
    private search = '';
    private availableTags: Array<{ id: number; name: string }> = [];
    private selectedTags: Array<number> = [];

    // copy mode stuff
    private isCopyMode = false;
    private selectedCopyTemplates: Array<MessageTableData> = [];
    private isCopyModalShown = false;
    private closeEvent = EventTypes.CLOSE;
    private updatedEvent = EventTypes.UPDATED;
    private viewEvent = EventTypes.VIEW;
    private batchUpdateFlag = false;
    private oldOptions: DataTableOptions = { itemsPerPage: 25, page: 1, sortBy: [], sortDesc: [] };
    private truncatedTags: { [key: string]: boolean } = {};

    get isCrmPlus(): boolean {
        return featuresStore.isFeatureEnabled(FeatureConstants.CRM_PLUS_MODE);
    }

    get isSuperUser() {
        return authState.isSuperuser;
    }

    get isCorpUser() {
        return authState.isCorporateUser;
    }

    get hasTextMessagingService() {
        return clientInfoStore.hasTextMessagingService;
    }

    get canAddEditTemplate() {
        if (this.isTemplate) {
            if (this.isSuperUser) {
                return true;
            }

            if (!this.isCrmPlus && this.isCorpUser) {
                return true;
            }

            if (this.automationMessageTemplatesPermissionGrant) {
                return true;
            }
        }

        return false;
    }

    private get messageTemplateHeaders() {
        const messageTemplateTableDataHeaders: Array<DataTableHeader> = [
            { text: 'Template Name', value: 'name' },
            { text: 'Type', value: 'type' }
        ];

        if (this.isTemplate) {
            messageTemplateTableDataHeaders.push(
                { text: 'Location(s) Available', value: 'location' }
            );

            // Add Tags column if both feature flags are enabled
            if (this.isTagsFeatureEnabled) {
                messageTemplateTableDataHeaders.push(
                    { text: 'Tag(s)', value: 'tags' }
                );
            }

            messageTemplateTableDataHeaders.push(
                { text: 'Subject (Emails only)', value: 'subject' },
                { text: 'Modified', value: 'last_edited_datetime', width: this.modifiedWidth }
            );
        } else {
            messageTemplateTableDataHeaders.push(
                { text: 'Subject (Emails only)', value: 'subject' },
                { text: 'Modified', value: 'last_edited_datetime' },
                { text: 'Modified By', value: 'last_edited_by_staff' }
            );
        }
        return messageTemplateTableDataHeaders;
    }

    /**
     * Formatted items to use in the table.
     */
    private get messageTemplates(): Array<MessageTableData> {
        return this.templates.map((message: MessageTemplate | Reminder) => {
            return {
                id: message.id,
                name: message.name,
                type: message.media_type ?? '',
                subject: message.subject ?? '',
                last_edited_datetime: this.formatDate(message.last_edited_datetime!),
                last_edited_by_staff: this.staffName(message),
                location: this.getLocationName(message),
                item_key: message.media_type + '-' + message.id
            };
        });
    }

    private get modifiedWidth() {
        switch (this.crmBreakpoint) {
        case 'sm':
            return '11ch';
        case 'md':
            return '13ch';
        case 'lg':
            return '14ch';
        case 'xl':
            return '15ch';
        }
    }

    /**
     * The current org the user is at within the UI.
     */
    get org() {
        return appState.storedCurrentOrg;
    }

    get showCopyButton() {
        return (this.isCorpUser || this.isSuperUser) && this.isTemplate;
    }

    get isTagsFeatureEnabled() {
        return featuresStore.isNewMarketingTemplates && featuresStore.isFeatureEnabled(FeatureConstants.TEMPLATE_TAGS);
    }

    /**
     * Templates or reminders retrieved from the API.
     */
    private get templates(): Array<MessageTemplate | Reminder> {
        // Duplicate logic from above with constants, otherwise, the reminders won't be reactive to the store
        const reminders = [...emailReminderStore.stored, ...textReminderStore.stored];
        for (const reminder of reminders) {
            reminder.media_type = this.templateType(reminder);
        }

        return reminders;
    }

    @Watch('isCopyMode')
    copyModeStarted() {
        if (this.isCopyMode) {
            this.selectedCopyTemplates = [];
        }
    }

    @Watch('isTemplate')
    private async loadOtherTemplates() {
        await this.fetchTemplates();

        if (!this.isTemplate) {
            this.search = '';
        }
    }

    // Watch for changes to the Datatables options -- pagination.
    @Watch('options')
    async onOptionsChange() {
        if (!this.batchUpdateFlag && ((this.options.page !== this.oldOptions.page || this.options.itemsPerPage !== this.oldOptions.itemsPerPage) || (this.options.sortBy !== this.oldOptions.sortBy || this.options.sortDesc !== this.oldOptions.sortDesc))) {
            this.oldOptions.itemsPerPage = this.options.itemsPerPage;
            this.oldOptions.page = this.options.page;
            this.oldOptions = { ...this.options };
            await this.getTemplateItems();
        }
        if (this.isCopyMode) {
            this.selectedCopyTemplates = this.selectedCopyTemplates.filter((template) => {
                return this.templateItems.map((item) => {
                    return item.item_key;
                }).includes(template.item_key);
            });
        }
    }

    @Watch('org')
    private async orgChanged() {
        await this.getTemplateItems();
    }

    /** lifecycle hooks */
    private async created() {
        const promises = [];
        promises.push(featuresStore.init());
        if (!this.isTemplate) {
            promises.push(this.fetchTemplates());
        }
        await Promise.all(promises);

        if (this.isCrmPlus) {
            this.automationMessageTemplatesPermissionGrant = await staffUtils.getUserPermission(PermissionName.AutomationMessageTemplates);
        }

        this.rootOrg = await orgStore.getOrgById(1);
        if (this.isTemplate && this.isTagsFeatureEnabled) {
            await this.loadAvailableTags();
        }
    }

    private async loadAvailableTags() {
        try {
            const tags = await templateTagsRepo.getAllTags();
            this.availableTags = processTemplateTags(tags);
        } catch (e) {
            this.availableTags = [];
        }
    }

    private async onTagSelectionChange() {
        this.options.page = 1;
        await this.getTemplateItems();
    }

    /**
     * @param itemRow - The template row data from the table
     */
    private async editTemplate(itemRow: MessageTableData) {
        if (this.isTemplate) {
            this.selectedItem = itemRow;
        } else {
            this.selectedItem = this.templates.find(template => template.id === itemRow.id &&
                template.media_type === itemRow.type) as MessageTemplate;
        }

        if (!this.selectedItem.id) {
            return;
        }

        let routeName: string;
        if (this.isEmail(this.selectedItem)) {
            routeName = this.isTemplate ? 'template-editor-email' : 'template-editor-email-reminder';
        } else {
            routeName = this.isTemplate ? 'template-editor-text' : 'template-editor-text-reminder';
        }

        const routeParams = { id: this.selectedItem.id.toString() };
        if (this.isNewMarketingTemplates && this.isTemplate) {
            const tabTitle = this.selectedItem.name || 'Template';

            if (this.canAddTabs) {
                await layoutTabsStore.addTab({
                    routeName,
                    routeParams,
                    goTo: true,
                    tabTitle
                });
            } else {
                const route = this.$router.resolve({
                    name: routeName,
                    params: routeParams
                });
                window.open(route.href, '_blank');
            }
        } else {
            await this.$router.push({
                name: routeName,
                params: routeParams
            });
        }
    }

    /** methods */
    private async clearSearch() {
        // Update items, no search term.
        this.search = '';
        await this.getTemplateItems();
    }

    private async doSearch() {
        if (!this.search) {
            // Update items, no search term.
            await this.getTemplateItems();
            return;
        }

        if (this.search.length < 3) {
            // Do not search unless we have at least 3 characters
            return;
        }

        await this.getTemplateItems();
    }

    private extractArray(str: string): MessageTableData[] {
        const start = str.indexOf('[');
        if (start === -1) return [];

        let count = 1;
        let i = start + 1;

        while (count > 0 && i < str.length) {
            if (str[i] === '[') count++;
            if (str[i] === ']') count--;
            i++;
        }

        if (count !== 0) return [];

        try {
            const arrayString = str.slice(start, i);
            const parsedArray = JSON.parse(arrayString);
            return Array.isArray(parsedArray) ? parsedArray : [];
        } catch (e) {
            return [];
        }
    }

    private async getTemplateItems() {
        if (!this.org) {
            return;
        }
        this.isLoading = true;
        const pagination = getPagination(this.options);
        const extraParams: ApiParameters = getSortingParameters(this.options, 'name');
        extraParams.org_id = this.org.id;

        if (this.search) {
            extraParams.search = this.search;
        }

        if (this.isTagsFeatureEnabled && this.selectedTags && this.selectedTags.length > 0) {
            extraParams.tags = this.selectedTags.join(',');
            extraParams['tag-filter-mode'] = 'all';
        }

        const data = await templatesRepo.get(pagination, extraParams);

        try {
            this.templateItems = data.entities.map((message: MessageTemplate) => {
                return {
                    id: message.id,
                    name: message.name,
                    type: message.media_type ?? '',
                    subject: message.subject ?? '',
                    last_edited_datetime: this.formatDate(message.last_edited_datetime!),
                    last_edited_by_staff: this.staffName(message),
                    location: this.getLocationName(message),
                    item_key: message.media_type + '-' + message.id,
                    tags: formatTemplateTags(message.tags)
                };
            });
        } catch (e) {
            const extractedArray = this.extractArray(data.entities as unknown as string);

            this.templateItems = extractedArray.map((message: any) => {
                return {
                    id: message.id,
                    name: message.name,
                    type: message.media_type ?? '',
                    subject: message.subject ?? '',
                    last_edited_datetime: this.formatDate(message.last_edited_datetime),
                    last_edited_by_staff: this.staffName(message),
                    location: this.getLocationName(message),
                    item_key: message.media_type + '-' + message.id,
                    tags: formatTemplateTags(message.tags)
                };
            });
        }

        this.currentItemCount = Number(data.count);
        const maxPage = Math.ceil(this.currentItemCount / this.options.itemsPerPage);
        if (this.options.page > maxPage) {
            this.options.page = Math.max(1, maxPage);
        }
        this.updateTruncatedTags();
        this.isLoading = false;
    }

    // This is for both templates & reminders now.
    private async fetchTemplates() {
        loadingState.loadingIncrement(this.loadingKey);
        // Retrieve templates/reminders in parallel
        if (!this.isTemplate) {
            const emailPromise = emailReminderStore.init();
            const promisesToAwait = [emailPromise];
            if (this.hasTextMessagingService) {
                const textPromise = textReminderStore.init();
                promisesToAwait.push(textPromise);
            }
            await Promise.all(promisesToAwait);
        } else {
            await this.getTemplateItems();
        }

        loadingState.loadingDecrement(this.loadingKey);
    }

    isEmail(template: MessageTemplate | Reminder | MessageTableData): boolean {
        if ('type' in template && 'location' in template) {
            return template.type === 'Email';
        }

        return 'subject' in template;
    }

    staffName(template: MessageTemplate | Reminder): string {
        return template.last_edited_by_staff
            ? `${template.last_edited_by_staff.values.first_name} ${template.last_edited_by_staff.values.last_name}`
            : '';

    }

    private getLocationName(template: MessageTemplate | Reminder): string {
        let location;

        if (this.isTemplate) {
            if ((template as MessageTemplate).brand !== null) {
                location = (template as MessageTemplate).brand?.values.name ?? this.rootOrg?.name ?? '';
            } else if ((template as MessageTemplate).location_group !== null) {
                location = (template as MessageTemplate).location_group?.values.value ?? this.rootOrg?.name ?? '';
            } else {
                location = (template as MessageTemplate).org?.values?.name ?? this.rootOrg?.name ?? '';
            }
        } else {
            location = this.rootOrg?.name ?? '';
        }

        return location;
    }

    async showLatest() {
        this.batchUpdateFlag = true;
        this.options.sortBy = ['last_edited_datetime'];
        this.options.sortDesc = [true];
        await this.getTemplateItems();
        this.batchUpdateFlag = false;
    }

    private updateTruncatedTags() {
        if (!this.isTagsFeatureEnabled) {
            return;
        }
        this.$nextTick(() => {
            const newTruncatedTags: { [key: string]: boolean } = {};
            this.templateItems.forEach(item => {
                const refName = `tags-${item.item_key}`;
                const element = this.$refs[refName] as HTMLElement | HTMLElement[] | undefined;
                if (element) {
                    const el = Array.isArray(element) ? element[0] : element;
                    if (el && el.scrollWidth > 0 && el.clientWidth > 0) {
                        newTruncatedTags[refName] = el.scrollWidth > (el.clientWidth + 1);
                    } else {
                        newTruncatedTags[refName] = false;
                    }
                } else {
                    newTruncatedTags[refName] = false;
                }
            });
            this.truncatedTags = newTruncatedTags;
        });
    }

    private isTagTruncated(itemKey: string): boolean {
        const refName = `tags-${itemKey}`;
        return this.truncatedTags[refName] === true;
    }

    private templateType(template: MessageTemplate | Reminder): string {
        if (template.media_type) {
            return template.media_type;
        }

        return template.subject !== undefined ? 'Email' : 'Text';
    }

    private getRowClass(): string {
        return 'template-row-focusable';
    }

    private isSelected(item: MessageTableData): boolean {
        return this.selectedCopyTemplates.some(selected => selected.item_key === item.item_key);
    }

    private toggleSelection(item: MessageTableData): void {
        const index = this.selectedCopyTemplates.findIndex(selected => selected.item_key === item.item_key);
        if (index > -1) {
            this.selectedCopyTemplates.splice(index, 1);
        } else {
            this.selectedCopyTemplates.push(item);
        }
    }
};
